import { CaseUtil } from '@vectord/utils';

export enum AllowedEmailTo {
  OWNER = 'owner',
  LEAD = 'lead',
}

export const allowedEmailToOptions = Object.values(AllowedEmailTo).map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));

export enum TaskScheduleUnitEnum {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
  YEARS = 'years',
}

export const taskScheduleUnitOptions = Object.values(TaskScheduleUnitEnum).map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));

export enum WebengageMappingSourceType {
  LEAD_ATTRIBUTE = 'lead_attribute',
  LEAD_ACTIVITY_ATTRIBUTE = 'lead_activity_attribute',
  STATIC = 'static',
  DEAL_ATTRIBUTE = 'deal_attribute',
}

export const webengageMappingSourceTypeOptions = Object.values(WebengageMappingSourceType).map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));

// The deal fields the backend reads off the deal event that triggered the automation
// (AutomationExecutors::Actions::SendWebengageEvent::DEAL_ATTRIBUTES).
export const webengageDealAttributeOptions = [
  { label: 'Deal Status', value: 'deal_status_name' },
  { label: 'Previous Deal Status', value: 'previous_deal_status_name' },
  { label: 'Product', value: 'product_name' },
];

// For a field that holds a user, such as Owner: send that user's name or email instead of their id.
export enum WebengageMappingUserField {
  NAME = 'name',
  EMAIL = 'email',
}

export const webengageMappingUserFieldOptions = Object.values(WebengageMappingUserField).map((value) => ({
  label: `User's ${value}`,
  value,
}));
